var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "bannerContainer"
  }, [_vm.activeBanner === 'free-plan' && _vm.showBanner ? _c('v-banner', {
    staticClass: "banner free-plan-banner",
    attrs: {
      "transition": "slide-y-transition",
      "color": "rgba(255, 219, 77, 0.5)"
    }
  }, [_c('v-row', {
    staticClass: "banner-row",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function ($event) {
        return _vm.goToUpgrade('banner_expired');
      }
    }
  }, [_c('v-col', {
    staticClass: "py-5 banner-text",
    attrs: {
      "align": "start"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.hasInactiveCodesToRestore ? 'banner.in_free_plan' : 'banner.in_free_plan_no_codes')) + " ")]), _c('button', {
    staticClass: "action-btn trial-action-btn mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.hasInactiveCodesToRestore ? 'banner.restore_service' : 'banner.upgrade_now')) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$close")])], 1)], 1)], 1) : _vm._e(), _vm.activeBanner === 'trial' && _vm.showBanner ? _c('v-banner', {
    staticClass: "banner trial-banner",
    class: {
      'trial-ending-banner': _vm.isTrialEndingSoon
    },
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('v-row', {
    staticClass: "banner-row",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function ($event) {
        return _vm.goToUpgrade('banner_trial');
      }
    }
  }, [_c('v-col', {
    staticClass: "py-5 banner-text",
    attrs: {
      "align": "start"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$tc(_vm.trialBannerMessage, _vm.trialRemainingDays, {
        days: _vm.trialRemainingDays
      }))
    }
  })]), _c('button', {
    staticClass: "action-btn trial-action-btn mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('banner.upgrade_now')) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$close")])], 1)], 1)], 1) : _vm._e(), _vm.activeBanner === 'subscription-ending' && _vm.showBanner ? _c('v-banner', {
    staticClass: "banner trial-banner",
    class: {
      'subscription-ending-banner': _vm.isSubscriptionEndingSoon
    },
    attrs: {
      "transition": "slide-y-transition",
      "color": "rgba(255, 219, 77, 0.5)"
    }
  }, [_c('v-row', {
    staticClass: "banner-row",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function ($event) {
        return _vm.goToProfile();
      }
    }
  }, [_c('v-col', {
    staticClass: "py-5 banner-text",
    attrs: {
      "align": "start"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('banner.ending_soon', {
        date: _vm.formatDate(_vm.currentPlan.valid_to)
      }))
    }
  })]), _c('button', {
    staticClass: "action-btn trial-action-btn mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('banner.resume_subscription')) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$close")])], 1)], 1)], 1) : _vm._e(), _vm.activeBanner === 'payment-past-due' && _vm.showBanner ? _c('v-banner', {
    staticClass: "banner payment-past-due-banner",
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('v-row', {
    staticClass: "banner-row",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function ($event) {
        return _vm.goToProfile();
      }
    }
  }, [_c('v-col', {
    staticClass: "py-5 banner-text",
    attrs: {
      "align": "start"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('banner.payment_past_due'))
    }
  })]), _c('button', {
    staticClass: "action-btn trial-action-btn mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('banner.update_billing')) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$close")])], 1)], 1)], 1) : _vm._e(), _vm.activeBanner === 'upcoming-renewal' && _vm.showBanner ? _c('v-banner', {
    staticClass: "banner upcoming-renewal-banner",
    attrs: {
      "transition": "slide-y-transition",
      "color": "rgba(255, 219, 77, 0.5)"
    }
  }, [_c('v-row', {
    staticClass: "banner-row",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function ($event) {
        return _vm.goToProfile();
      }
    }
  }, [_c('v-col', {
    staticClass: "py-5 banner-text",
    attrs: {
      "align": "start"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('banner.upcoming_renewal', {
        date: _vm.formatDate(_vm.currentPlan.valid_to)
      }))
    }
  })]), _c('button', {
    staticClass: "action-btn trial-action-btn mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('banner.update_billing')) + " ")]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("$close")])], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }